import React, { useEffect, useState } from "react";
import { PageHeader, Card, Tag } from "../components/UI";
import { Building2, Plus, X } from "lucide-react";
import api, { formatError } from "../lib/api";

export default function Tenants() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ name: "", code: "", program_name: "CBC", brand: "ZIXA Strong", primary_contact_email: "" });

  async function fetchTenants() {
    const { data } = await api.get("/tenants");
    setItems(data);
  }
  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const { data } = await api.get("/tenants");
        if (alive) setItems(data);
      } catch { /* swallow */ }
    })();
    return () => { alive = false; };
  }, []);

  async function submit(e) {
    e.preventDefault();
    try { await api.post("/tenants", form); setOpen(false); await fetchTenants(); } catch (e) { alert(formatError(e)); }
  }

  return (
    <div className="space-y-6">
      <PageHeader
        kicker="Administration"
        title="Tenant Management"
        subtitle="ChannelLoyalty.ai is multi-tenant by design. Jenburkt is Tenant #1; future deployments inherit the same isolated wallet, catalog and campaign primitives."
        testId="tenants-page"
        actions={<button onClick={() => setOpen(true)} className="btn-primary flex items-center gap-2" data-testid="add-tenant-btn"><Plus size={14} /> New tenant</button>}
      />

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {items.map((t) => (
          <Card key={t.id}>
            <div className="flex items-start justify-between">
              <div className="flex items-center gap-3">
                <div className="h-10 w-10 bg-brand-navy text-white rounded-md flex items-center justify-center serif-display text-xl">{t.name[0]}</div>
                <div>
                  <div className="font-medium text-slate-900">{t.name}</div>
                  <div className="text-[12px] text-slate-500">{t.program_name} · {t.brand}</div>
                </div>
              </div>
              <Tag tone="emerald">{t.status}</Tag>
            </div>
            <div className="grid grid-cols-3 mt-4 gap-2 text-[12px]">
              <div><div className="small-caps text-slate-400">Code</div><div className="font-mono mt-1">{t.code}</div></div>
              <div><div className="small-caps text-slate-400">Contact</div><div className="font-mono mt-1 text-[11px]">{t.primary_contact_email || "—"}</div></div>
              <div><div className="small-caps text-slate-400">Created</div><div className="mt-1">{new Date(t.created_at).toLocaleDateString()}</div></div>
            </div>
          </Card>
        ))}
      </div>

      {open && (
        <div className="fixed inset-0 bg-slate-900/30 z-40 flex items-center justify-center p-4" onClick={() => setOpen(false)}>
          <form onSubmit={submit} className="bg-white rounded-xl border border-slate-200 w-full max-w-md p-6 space-y-3" onClick={(e) => e.stopPropagation()}>
            <div className="flex items-center justify-between"><h3 className="serif-display text-2xl">New tenant</h3><button type="button" onClick={() => setOpen(false)}><X size={18} /></button></div>
            <div><label className="small-caps text-slate-500">Tenant name</label><input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} required /></div>
            <div><label className="small-caps text-slate-500">Code</label><input value={form.code} onChange={(e) => setForm({ ...form, code: e.target.value.toUpperCase() })} required /></div>
            <div><label className="small-caps text-slate-500">Program name</label><input value={form.program_name} onChange={(e) => setForm({ ...form, program_name: e.target.value })} /></div>
            <div><label className="small-caps text-slate-500">Brand</label><input value={form.brand} onChange={(e) => setForm({ ...form, brand: e.target.value })} /></div>
            <div><label className="small-caps text-slate-500">Primary contact email</label><input type="email" value={form.primary_contact_email} onChange={(e) => setForm({ ...form, primary_contact_email: e.target.value })} /></div>
            <button type="submit" className="btn-primary w-full">Create tenant</button>
          </form>
        </div>
      )}
    </div>
  );
}
